import { useEffect, useRef, useState } from 'react';
import { listContacts } from '../api/messages';

// Cerca i destinatari sul server: l'elenco chat caricato è solo la prima
// pagina, e un destinatario più vecchio non si troverebbe.
export default function ForwardDialog({ connection, onClose, onForward }) {
  const dialog = useRef(null);
  const [query, setQuery] = useState('');
  const [contacts, setContacts] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { const node = dialog.current; node.showModal(); return () => node.close(); }, []);
  useEffect(() => {
    let attiva = true;
    const timer = setTimeout(() => {
      listContacts({ connection, q: query.trim(), limit: 50 })
        .then(({ data }) => { if (attiva) setContacts(Array.isArray(data) ? data : data.results); })
        .catch(() => { if (attiva) setError('Impossibile cercare i destinatari.'); });
    }, query ? 300 : 0);
    return () => { attiva = false; clearTimeout(timer); };
  }, [connection, query]);
  return <dialog ref={dialog} onCancel={onClose} className="rounded-xl p-0 w-80 max-h-[80dvh] bg-surface" aria-label="Inoltra messaggio">
    <div className="flex justify-between p-4 border-b"><h2>Inoltra a…</h2><button aria-label="Chiudi inoltro" onClick={onClose}>✕</button></div>
    <input className="chat-search" placeholder="Cerca destinatario" aria-label="Cerca destinatario" value={query} onChange={e => setQuery(e.target.value)} />
    {error && <p role="alert" className="p-3 text-sm">{error}</p>}
    <div className="overflow-auto max-h-80">
      {contacts.map(c =>
        <button disabled={busy} key={c.id} className="block w-full text-left p-3 border-b" onClick={async () => { setBusy(true); setError(''); try { await onForward(c.whatsapp_id, c.name); } catch (_) { setError('Inoltro non confermato. Verifica la destinazione prima di riprovare.'); } finally { setBusy(false); } }}>{c.name}</button>)}
    </div>
  </dialog>;
}
